export default function preloaderGame7 (scene) {

    scene.load.image(`tilesgame7`, `/tiles/game7.png`);

	scene.load.audio("dejavuSong", ["/audio/songs/7-dejavu.mp3"]);

	scene.load.spritesheet(`jiu-game7`, 
		`/img/game7/jiu.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`sua-game7`, 
		`/img/game7/sua.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`siyeon-game7`, 
		`/img/game7/siyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`handong-game7`, 
		`/img/game7/handong.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`yoohyeon-game7`, 
		`/img/game7/yoohyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`dami-game7`, 
		`/img/game7/dami.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`gahyeon-game7`,
		`/img/game7/gahyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`enemy-game7`, 
		`/img/game7/yoohyeon-2.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`jiu2-game7`, 
		`/img/game7/jiu-2.png`,
		{ frameWidth: 27, frameHeight: 37}
	);
	
	scene.load.spritesheet(`humo-game7`, 
	`/img/generalSprites/humo-infinite.png`,
		{ frameWidth: 41, frameHeight: 42}
	);

	scene.load.spritesheet(`logo`, 
		`/img/game7/logo.png`,
		{ frameWidth: 30, frameHeight: 30}
	);

	scene.load.tilemapTiledJSON(`game7`, `/tiles/game7.tmj`);

}